module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v("Vozila")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "background": "#2b542c",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.openAddUserModal()
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" Dodaj vozilo\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "90%",
      "border-radius": "10px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pretraga",
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed",
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredUsers), function(user, index) {
    return _c('tr', {
      staticStyle: {
        "color": "white",
        "background-color": "#4E5066 !important"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm.filteredUsers.length - index) + ".")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(_vm.getFuel(user.fuel)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(user.registrationPlate))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(user.description))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(user.kilometersTraveled))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      },
      style: (_vm.styleService(user))
    }, [_vm._v(_vm._s(user.kilometersTraveled != null ? user.smallService - (user.kilometersTraveled - user.lastSmallService) : 0))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(user.averageSpending) + " ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      },
      style: (_vm.parseDate(user.registrationExpiration))
    }, [_vm._v(_vm._s(user.registrationExpiration))]), _vm._v(" "), _c('td', [_c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "cornflowerblue"
      },
      attrs: {
        "type": "button",
        "placeholder": "Troškovi",
        "name": "Troškovi",
        "value": "Troškovi"
      },
      on: {
        "click": function($event) {
          return _vm.openCosts(user)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "cornflowerblue"
      },
      attrs: {
        "type": "button",
        "placeholder": "Izmeni",
        "name": "Izmeni",
        "value": "Izmeni"
      },
      on: {
        "click": function($event) {
          return _vm.editVehicle(user)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "#843534"
      },
      attrs: {
        "type": "button",
        "placeholder": "Obriši",
        "name": "Obriši",
        "value": "Obriši"
      },
      on: {
        "click": function($event) {
          return _vm.deleteVehicle(user)
        }
      }
    })])])
  }), 0)])])])]), _vm._v(" "), _c('add-vehicle-modal', {
    attrs: {
      "show": _vm.openAddOrder,
      "vehicle": _vm.vehicleToEdit
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "40px",
      "color": "white"
    }
  }, [_vm._v("R. br")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Naziv")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Gorivo")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Tablice")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Opis")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Predjeni KM")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "300px",
      "color": "white"
    }
  }, [_vm._v("Mali servis za (KM)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "300px",
      "color": "white"
    }
  }, [_vm._v("Potrošnja (L/100KM)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "300px",
      "color": "white"
    }
  }, [_vm._v("Isticanje reg.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Troškovi")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Izmeni")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Obriši")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6bb93abe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Vehicle/Vehicle.vue
// module id = 491
// module chunks = 1